import { Notification } from "@/types";
import { create } from "zustand";

interface NotificationStore {
  editNotificationId: number | null;
  isEditModalOpen: boolean; // Open drawer for editing notification
  copyedNotification: {
    notification: Notification;
    isDeleteRecivers?: boolean;
  } | null; // Notification id to copy
  isCreateModalOpen: boolean; // Open drawer for creating new notification

  openEditModal: (id: number) => void;
  closeEditModal: () => void;
  setCopyedNotification: (
    notification: {
      notification: Notification;
      isDeleteRecivers?: boolean;
    } | null
  ) => void;
  openCreateModal: () => void;
  closeCreateModal: () => void;
  reset: () => void;
}

export const useNotificationStore = create<NotificationStore>((set) => ({
  editNotificationId: null,
  isEditModalOpen: false,
  isCreateModalOpen: false,
  copyedNotification: null,
  openEditModal: (id: number) =>
    set({ editNotificationId: id, isEditModalOpen: true }),
  closeEditModal: () =>
    set({ editNotificationId: null, isEditModalOpen: false }),
  openCreateModal: () => set({ isCreateModalOpen: true }),
  closeCreateModal: () => set({ isCreateModalOpen: false }),
  setCopyedNotification: (copyedNotification) =>
    set({
      copyedNotification: copyedNotification,
      isCreateModalOpen: true,
    }),
  reset: () => {
    set({
      editNotificationId: null,
      isEditModalOpen: false,
      isCreateModalOpen: false,
      copyedNotification: null,
    });
  },
}));
